import { DateField as RADateField } from 'react-admin'

const DateField = RADateField

DateField.defaultProps = {
  locales: 'fr-FR',
}

export default DateField
